import { render, staticRenderFns } from "./create.vue?vue&type=template&id=b6d13c6c"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6d13c6c')) {
      api.createRecord('b6d13c6c', component.options)
    } else {
      api.reload('b6d13c6c', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=b6d13c6c", function () {
      api.rerender('b6d13c6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/loop/create.vue"
export default component.exports